import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import formatDate from "../../common/Formatdate";
import toast from "react-hot-toast";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import getActionsRoles from "../../common/actionsrols";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { OrbitProgress, BlinkBlur } from "react-loading-indicators";
import getactions from "../../common/getactions";

const style = {
  position: "fixed",   // <--- change here
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const imagestyle = {
  position: "fixed", // <--- change here
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Pettcashdetailtab = ({
  setSelectedRow,
  setOpenTab,
  selectedRow,
  getTableData,
  setStatusType,
  setCategoryId,
  setExecutiveId,
  setVehicleId,
  formattedStartDate,
  formattedEndDate,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const pettyCashStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashStatus;
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).resourceTypes;
  const pettyCashTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.pettyCashTypes;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [cashDetails, setCashDetails] = useState(null);
  const [comment, setComment] = useState(null);
  const [fetcHActionRoles, setFetchActionRoles] = useState(null);
  const [approvalImage, setApprovalImage] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [billDetails, setBillDetails] = useState([]);
  const [transactionImages, setTransactionImages] = useState([]);
  const [billImages, setBillImages] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState(""); // 'transaction' or 'bill'
  const [loading, setLoading] = useState(false);
  const [approvalDetails, setApprovalDetails] = useState(null);
  const [dataforSubCategory, setDataforSubCategory] = useState(null);
  const [specificPettyCashDetails, setSpecificPettyCashDatails] = useState([]);
  const [userList, setUserList] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);

  const handleImageClose = () => {
    setImageSelection(null);
    setOpenImage(false);
  };

  const handleImageOpen = (url) => {
    setImageSelection(url);
    setOpenImage(true);
  };

  const actionsToAccess = getactions(profile?.roles, profile?.actions);

  function createData(
    Type,
    TransactionId,
    Amount,
    Charges,
    Payment,
    Remarks,
    Image
  ) {
    return {
      Type,
      TransactionId,
      Amount,
      Charges,
      Payment,
      Remarks,
      attachments: Image,
    };
  }

  const rows = transactionDetails?.map((item) =>
    createData(
      item?.transactionType,
      item?.transactionId,
      item?.transactionAmount,
      item?.transactionCharges,
      item?.modeOfPayment,
      item?.transactionRemark,
      JSON.parse(item?.attachments) || []
    )
  );

  function createBillData(
    InvoiceNo,
    TaxAmount,
    DiscountAmount,
    InvoiceAmount,
    TotalItemCost,
    Image
  ) {
    return {
      InvoiceNo,
      TaxAmount,
      DiscountAmount,
      InvoiceAmount,
      TotalItemCost,
      attachments: Image,
    };
  }

  const billRows = billDetails.map((item) =>
    createBillData(
      item?.invoiceNumber,
      item?.taxAmount,
      item?.discountAmount,
      item?.invoiceAmount,
      item?.totalItemCost,
      JSON.parse(item?.invoiceAttachments) || []
    )
  );

  // const getSpecificPettyCashes = async () => {
  //   const user = userList.find((item) => item?.id === cashDetails?.createdBy);
  //   const createdById = user?.id || cashDetails?.createdBy; // fallback if not found

  //   try {
  //     let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&pettyCashStatus=${cashDetails?.pettyCashStatus}&cashFor=${cashDetails?.cashFor}&createdBy=${createdById}`;

  //     const response = await fetch(`${apiUrl}/api/pettycashes?${query}`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       setSpecificPettyCashDatails(data?.entities?.rows);
  //     } else {
  //       console.error("Unexpected API response:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching petty cash Table Data:", error);
  //   }
  // };

  function employeeData(amount, requestedby, createdat, cashfor) {
    return { amount, requestedby, createdat, cashfor };
  }

  const rowsEmplyee = specificPettyCashDetails?.map((item) =>
    employeeData(
      item?.amount,
      item?.requestBy,
      formatDate(item?.createdAt),
      pettyCashTypes[item?.cashFor]
    )
  );

  const handleOpen = (type) => {
    if (type === "transaction") {
      if (
        !isUserAuthorizedForAmount(
          cashDetails?.amount,
          approvalDetails,
          profile?.id
        )
      ) {
        toast.error("You are not authorized to approve this transaction.");
        return;
      }
    }
    setModalType(type); // 'transaction' or 'bill'
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setInputValues({});
    setTransactionImages([]);
    setBillImages([]);
  };

  const attachments = cashDetails?.attachments
    ? JSON.parse(cashDetails.attachments)
    : [];

  const imageData = attachments;

  const settings = {
    dots: true,
    infinite: imageData?.length > 1, // only loop if more than one
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  useEffect(() => {
    if (selectedRow?.pettycashid) {
      setLoading(true);
      getPettycashDetails(selectedRow?.pettycashid);
      getTransactionDetailsApi(
        selectedRow.pettycashid,
        resourceTypes?.inverted?.["pettyCashes"]
      );
      getBillDetailsApi(
        selectedRow.pettycashid,
        resourceTypes?.inverted?.["pettyCashes"]
      );
    }
  }, [selectedRow]);

  const handleSubCategory = async () => {
    let key = Object.keys(pettyCashTypes).find(
      (k) => pettyCashTypes[k] === "Delivery Reimbursement"
    );
    try {
      const response = await fetch(
        `${apiUrl}/api/catalogs/get-all?parentId=${cashDetails?.subCategory}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setDataforSubCategory(data.entities?.rows);
      }
    } catch (error) {
      return console.error("Error fetching sub category:", error);
    }
  };

  useEffect(() => {
    getActionsRoles().then((fetcHActionRoles) =>
      setFetchActionRoles(fetcHActionRoles)
    );
    getApprovalDetails();
    handleSubCategory();
  }, []);

  const getUsersLimitDetails = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=1000&isSystemUser=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setUserList(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error(
        "Error fetching user limits list in the fuel details tab:",
        error
      );
    }
  };

  useEffect(() => {
    if (
      pettyCashTypes[cashDetails?.cashFor] ===
      "Pickup And Delivery Reimbursement"
    ) {
      getUsersLimitDetails();
    }
  }, [cashDetails]);

  // useEffect(() => {
  //   if (cashDetails && userList.length > 0) {
  //     getSpecificPettyCashes();
  //   }
  // }, [userList, cashDetails, formattedStartDate, formattedEndDate]);

  const getApprovalDetails = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/pettycashapprovalconfigs?limit=100`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setApprovalDetails(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching get common transactions:", error);
    }
  };

  const handleUploadImage = async (event, type) => {
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "pettyCash");
    formData.append("fileTags", "vehicle");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        setLoading(false);
        if (type === "transaction") {
          setTransactionImages(data?.uploaded);
        } else {
          setBillImages(data?.uploaded);
        }
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleApproveCashRequest = async (statusType) => {
    if (statusType === pettyCashStatus?.inverted?.transactionPending) {
    }

    const payload = {
      id: cashDetails?.id,
      approvalComment: comment,
      approvedBy: profile?.name,
      approvedByEmail: profile?.email,
      pettyCashStatus: statusType,
      issueId: cashDetails?.issueId || null,
      pettyCashCode: cashDetails?.pettyCashCode,
      amount: cashDetails?.amount,
      approvalAttachments: JSON.stringify(approvalImage?.uploaded),
      updateIds: cashDetails?.id,
    };

    try {
      const response = await toast.promise(
        fetch(`${apiUrl}/api/pettycashes`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        }),
        {
          loading: "Approving...",
          success: <b>Approved successfully!</b>,
          error: <b>Approval failed!</b>,
        }
      );

      const data = await response.json();
      if (data) {
        setCashDetails(data?.dataValues);
        setComment(null);
        setApprovalImage(null);
        setComment(null);
        await getPettycashDetails(data?.dataValues?.id);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }
  };

  const getPettycashDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/pettycashes/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setLoading(false);
        setCashDetails(data?.entityValue);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleInputValueChanges = (field, event) => {
    const value = event.target.value;
    const key = field?.value;

    if (key) {
      setInputValues((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const modeofPayments = {
    cash: "Cash",
    cheque: "Cheque",
    upi: "UPI",
    netbanking: "Net Banking",
    creditcard: "Credit Card",
    debitcard: "Debit Card",
  };

  let transactionInputField = [
    {
      label: "Transaction ID",
      type: "number",
      value: "transactionId",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Charges",
      type: "number",
      value: "transactionCharges",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Amount",
      type: "number",
      value: "transactionAmount",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Remark",
      type: "text",
      value: "transactionRemark",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Mode",
      type: "text",
      value: "transactionMode",
      valueType: "dropdown",
      subCategory: Object.entries(modeofPayments).map(([value, item]) => ({
        value, // e.g., "cash"
        item, // e.g., "Cash"
      })),
    },
  ];

  let billInputField = [
    {
      label: "Invoice No",
      type: "text",
      value: "invoiceNo",
      valueType: "text",
    },
    {
      label: "Tax Amount",
      type: "number",
      value: "taxAmount",
      valueType: "text",
    },
    {
      label: "Discount Amount",
      type: "number",
      value: "discountAmount",
      valueType: "text",
    },
    {
      label: "Invoice Amount",
      type: "number",
      value: "invoiceAmount",
      valueType: "text",
    },
    {
      label: "Total Item Cost",
      type: "number",
      value: "totalItemCost",
      valueType: "text",
    },
  ];

  const isUserAuthorizedForAmount = (amount, approvalDetails, userId) => {
    const eligibleConfigs = approvalDetails?.filter(
      (config) => amount <= config.amount
    );
    let allApprovalIds = [];
    eligibleConfigs?.forEach((config) => {
      try {
        const ids = JSON.parse(config.approvalIds || "[]").map(Number);
        allApprovalIds = allApprovalIds.concat(ids);
      } catch {}
    });
    return [...new Set(allApprovalIds)].includes(userId);
  };

  const handleSumbit = async (type) => {
    if (type === "transaction") {
      if (Object.keys(inputValues).length) {
        try {
          const response = await fetch(`${apiUrl}/api/commontransactions`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              resourceType: resourceTypes?.inverted?.["pettyCashes"],
              resourceId: cashDetails?.id,
              transactionId: inputValues?.transactionId, // dynamic
              transactionCharges: inputValues?.transactionCharges, // dynamic
              modeOfPayment: inputValues?.transactionMode, // dynamic
              transactionAmount: inputValues?.transactionAmount, // dynamic
              transactionRemark: inputValues?.transactionRemark, // dynamic
              transactionType: "debit",
              attachments: JSON.stringify(transactionImages || []),
            }),
          });
          const data = await response.json();
          if (data?.statusCode === "0100") {
            setOpen(false);
            setInputValues({});
            setTransactionImages([]);
            const responseData = data?.dataValues;
            await getTransactionDetailsApi(
              responseData?.resourceId,
              responseData?.resourceType
            );
          } else {
            setOpen(false);
            setInputValues({});
            setTransactionImages([]);
            toast.error(
              "Transaction Data not saved. Please fill all the details"
            );
          }
        } catch (error) {
          console.error("Error fetching post common transactions:", error);
        }
      } else {
        toast.error("Please fill all the fields");
      }
    } else if (type === "bill") {
      if (Object.keys(inputValues).length) {
        try {
          const response = await fetch(`${apiUrl}/api/invoices`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              resourceType: resourceTypes?.inverted?.["pettyCashes"],
              resourceId: cashDetails?.id,
              invoiceNumber: inputValues?.invoiceNo,
              taxAmount: inputValues?.taxAmount,
              discountAmount: inputValues?.discountAmount,
              invoiceAmount: inputValues?.invoiceAmount,
              totalItemCost: inputValues?.totalItemCost,
              invoiceAttachments: JSON.stringify(billImages || []),
            }),
          });
          const data = await response.json();
          if (data) {
            setOpen(false);
            setInputValues({});
            setTransactionImages([]);
            const responseData = data?.dataValues;
            await getBillDetailsApi(
              responseData?.resourceId,
              responseData?.resourceType
            );
          } else {
            console.error("Unexpected API response:", data);
          }
        } catch (error) {
          console.error("Error fetching post invoice:", error);
        }
      }
    }
  };

  const getTransactionDetailsApi = async (id, type) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/commontransactions?resourceType=${type}&resourceId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTransactionDetails(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching get transaction details:", error);
    }
  };

  const getBillDetailsApi = async (id, type) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/invoices?resourceType=${type}&resourceId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBillDetails(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching get invoice:", error);
    }
  };

  // const handleDownload = async (e, url, filename) => {
  //   try {
  //     const response = await fetch(url, {
  //       mode: "cors", // if server supports CORS
  //     });

  //     if (!response.ok) {
  //       throw new Error("Network response was not ok");
  //     }

  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.download = filename;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Image download failed:", error);
  //   }
  // };

  return (
    <>
      {openImage && (
        <Modal
          keepMounted
          open={openImage}
          onClose={handleImageClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={imagestyle}>
            <div>
              <img
                className="h-full w-full"
                src={imageSelection}
                alt="attachment"
              />
            </div>
          </Box>
        </Modal>
      )}
      {open && (
        <Modal
          keepMounted
          open={open}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <div className="grid grid-cols-2 gap-4">
              {modalType === "transaction" ? (
                <>
                  {transactionInputField.map((field, idx) =>
                    field.valueType === "text" ? (
                      <TextField
                        key={idx}
                        // type={field?.type}
                        fullWidth
                        label={field.label}
                        variant="outlined"
                        type={field.valueType}
                        onChange={(event) => {
                          handleInputValueChanges(field, event);
                        }}
                        // InputProps={{
                        //   inputProps: {
                        //     inputMode:
                        //       field.type === "number" ? "numeric" : "text",
                        //     pattern:
                        //       field.type === "number"
                        //         ? "[0-9.]*"
                        //         : "[A-Za-z ]*",
                        //   },
                        // }}
                      />
                    ) : (
                      <FormControl fullWidth>
                        <InputLabel id="drop-label">{field?.label}</InputLabel>
                        <Select
                          key={idx}
                          labelId="drop-label"
                          value={inputValues[field.value] || ""}
                          onChange={(event) =>
                            handleInputValueChanges(field, event)
                          }
                          label={field?.label}
                        >
                          {field?.subCategory?.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              {option.item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )
                  )}
                </>
              ) : (
                <>
                  {billInputField.map((field, idx) =>
                    field.valueType === "text" ? (
                      <TextField
                        key={idx}
                        // type={field?.type}
                        fullWidth
                        label={field.label}
                        variant="outlined"
                        type={field.valueType}
                        onChange={(event) => {
                          handleInputValueChanges(field, event);
                        }}
                        // InputProps={{
                        //   inputProps: {
                        //     inputMode:
                        //       field.type === "number" ? "numeric" : "text",
                        //     pattern:
                        //       field.type === "number"
                        //         ? "[0-9.]*"
                        //         : "[A-Za-z ]*",
                        //   },
                        // }}
                      />
                    ) : (
                      <FormControl fullWidth>
                        <InputLabel id="drop-label">{field?.label}</InputLabel>
                        <Select
                          key={idx}
                          labelId="drop-label"
                          value={inputValues[field.value] || ""}
                          onChange={(event) =>
                            handleInputValueChanges(field, event)
                          }
                          label={field?.label}
                        >
                          {field?.subCategory?.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              {option.item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )
                  )}
                </>
              )}
              <div className="bg-white md:col-span-2 border rounded-xl shadow-md p-4">
                <h1 className="text-center mb-4 font-semibold">
                  {modalType === "transaction"
                    ? "Transaction Image"
                    : "Bill Image"}
                </h1>
                {loading && (
                  <div className="flex flex-col items-center justify-center">
                    <OrbitProgress
                      variant="spokes"
                      color="#557af2"
                      size="medium"
                      text="Image Uploading"
                      textColor="#aeb7fb"
                    />
                  </div>
                )}
                {transactionImages.length || billImages.length ? (
                  modalType === "transaction" ? (
                    transactionImages.length > 0 &&
                    (transactionImages.length > 1 ? (
                      <Slider {...settings}>
                        {transactionImages.map((img, idx) => (
                          <div key={idx}>
                            <img
                              src={img?.url}
                              alt={`Preview ${idx}`}
                              className="w-full h-64 object-contain rounded"
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <img
                        src={transactionImages[0]?.url}
                        alt="Preview"
                        className="w-full h-64 object-contain rounded"
                      />
                    ))
                  ) : (
                    billImages.length > 0 &&
                    (billImages.length > 1 ? (
                      <Slider {...settings}>
                        {billImages.map((img, idx) => (
                          <div key={idx}>
                            <img
                              src={img?.url ? img?.url : img.path}
                              alt={`Preview ${idx}`}
                              className="w-full h-64 object-contain rounded"
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <img
                        src={
                          billImages[0]?.url
                            ? billImages[0]?.url
                            : billImages[0]?.path
                        }
                        alt="Preview"
                        className="w-full h-64 object-contain rounded"
                      />
                    ))
                  )
                ) : (
                  <div className="flex justify-center">
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                    >
                      Upload File
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(event) => {
                          handleUploadImage(event, modalType);
                        }}
                        multiple
                      />
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div className="flex mt-6 mx-auto gap-4">
              <Button
                onClick={() => {
                  handleSumbit(modalType);
                }}
                variant="contained"
              >
                Submit
              </Button>
              <Button
                onClick={() => {
                  setInputValues({});
                  setOpen(false);
                  setTransactionImages([]);
                  setBillImages([]);
                }}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      <div className="p-1 mt-6 overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="font-bold md:text-2xl text-gray-800">
            Petty Cash Details
          </h1>
          <Button
            onClick={() => {
              setSelectedRow(null);
              setOpenTab(false);
              getTableData();
              // setStatusType(null);
              // setCategoryId(null);
              // setExecutiveId(null);
              // setVehicleId(null);
            }}
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            sx={{
              fontWeight: "bold",
              backgroundColor: "#1a53ff",
              color: "white",
            }}
            className="rounded-full"
          >
            Go Back
          </Button>
        </div>
      </div>

      {loading ? (
        <>
          <div className="flex items-center justify-center h-screen w-full">
            {/* <OrbitProgress
              variant="spokes"
              color="#050dff"
              size="large"
              text="Data Loading"
              textColor="#aeb7fb"
            /> */}

            <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
          </div>
        </>
      ) : (
        <>
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Details Card */}
              <div className="md:col-span-2 bg-white border rounded-xl shadow-md p-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {[
                    { label: "ID", value: cashDetails?.id || "-" },
                    { label: "Code", value: cashDetails?.pettyCashCode || "-" },
                    {
                      label: "Cash For",
                      value: pettyCashTypes[cashDetails?.cashFor],
                    },
                    { label: "Amount", value: cashDetails?.amount || "-" },
                    {
                      label: "Vehicle Name",
                      value: cashDetails?.vehicleName || "-",
                    },
                    {
                      label: "vehicle Number",
                      value: cashDetails?.registrationNo || "-",
                    },
                    {
                      label: "Generate On",
                      value: formatDate(cashDetails?.updatedAt || "-"),
                    },
                    { label: "City", value: cashDetails?.cityName || "-" },
                    { label: "Hub", value: cashDetails?.hubName || "-" },
                    {
                      label: "Request By",
                      value: cashDetails?.requestBy || "-",
                    },
                    {
                      label: "Request On",
                      value: formatDate(cashDetails?.updatedAt || "-"),
                    },
                    {
                      label: "Status",
                      value: pettyCashStatus[cashDetails?.pettyCashStatus],
                      isStatus: true,
                    },
                    {
                      label: "Description",
                      value: cashDetails?.description || "-",
                    },
                    {
                      label: "Booking Id",
                      value: cashDetails?.bookingCode
                        ? cashDetails?.bookingCode
                        : cashDetails?.bookingId
                        ? cashDetails?.bookingId
                        : "N/A",
                    },
                    cashDetails?.subCategory
                      ? {
                          label: "Delivery Type",
                          value:
                            cashDetails?.subCategory === 595
                              ? "Drop"
                              : "Pickup",
                        }
                      : {},
                    cashDetails?.fuelCardNo
                      ? {
                          label: "Fuel Card No",
                          value: cashDetails?.fuelCardNo,
                        }
                      : {},
                      cashDetails?.approvalComment
                      ? {
                          label: "Comment for Approved / Rejected",
                          value: cashDetails?.approvalComment,
                        }
                      : {},
                  ].map(({ label, value, isStatus }, idx) => (
                    <div key={idx}>
                      <h2 className="text-sm font-medium text-gray-600 mb-1">
                        {label}
                      </h2>
                      {isStatus ? (
                        <p
                          className={`inline-block px-3 py-1 rounded-lg text-sm font-semibold ${
                            value === "Cash Completed"
                              ? "bg-green-100 text-green-800"
                              : value === "Rejected"
                              ? "bg-red-100 text-red-800"
                              : "bg-yellow-100 text-yellow-800"
                          }`}
                        >
                          {value}
                        </p>
                      ) : (
                        <p className="text-gray-800 font-medium">{value}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="md:col-span-1 bg-white p-4 border rounded-xl shadow-lg">
                <div className="w-full">
                  {imageData?.length > 1 ? (
                    <Slider {...settings}>
                      {imageData.map((img, idx) => (
                        <div key={idx} className="px-1">
                          <img
                            src={img?.url || img?.path}
                            alt={`Preview ${idx}`}
                            onError={(e) => (e.target.src = "/placeholder.jpg")}
                            className="w-full h-96 object-cover rounded-xl border shadow-md"
                            onClick={() => {
                              handleImageOpen(img?.url ? img?.url : img?.path);
                            }}
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    imageData?.[0] && (
                      <img
                        src={imageData[0]?.url || imageData[0]?.path}
                        onClick={() => {
                          handleImageOpen(
                            imageData[0]?.url
                              ? imageData[0]?.url
                              : imageData[0]?.path
                          );
                        }}
                        alt="Preview"
                        onError={(e) => (e.target.src = "/placeholder.jpg")}
                        className="w-full h-96 object-cover cursor-pointer rounded-xl border shadow-md"
                      />
                    )
                  )}
                </div>
              </div>
            </div>
          </>

          {
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="col-span-1">
                {actionsToAccess?.includes("Approve Petty Cash Request") &&
                  transactionDetails.length === 0 &&
                  cashDetails?.pettyCashStatus ===
                    Number(pettyCashStatus?.inverted?.requested) && (
                    <div className="gap-6 mt-4 p-4">
                      <TextField
                        sx={{
                          width: "70%",
                        }}
                        label="Reject Reason"
                        variant="outlined"
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#f23029",
                          "&:hover": { backgroundColor: "#f54a45" },
                          px: 4,
                          py: 1.5,
                          borderRadius: 2,
                          fontWeight: "bold",
                          my: 2,
                        }}
                        onClick={() =>
                          handleApproveCashRequest(
                            pettyCashStatus?.inverted?.rejected
                          )
                        }
                      >
                        Reject Request
                      </Button>
                    </div>
                  )}
              </div>

              <div className="col-span-1">
                {actionsToAccess?.includes("Approve Petty Cash Request") &&
                  cashDetails?.pettyCashStatus ===
                    Number(pettyCashStatus?.inverted?.requested) && (
                    <div className="gap-6 mt-4 p-4">
                      <TextField
                        sx={{
                          width: "80%",
                        }}
                        label="Description"
                        variant="outlined"
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#6582eb",
                          "&:hover": { backgroundColor: "#859df2" },
                          px: 4,
                          py: 1.5,
                          borderRadius: 2,
                          fontWeight: "bold",
                          my: 2,
                        }}
                        onClick={() =>
                          handleApproveCashRequest(
                            pettyCashStatus?.inverted?.verified
                          )
                        }
                      >
                        Verify Request
                      </Button>
                    </div>
                  )}
              </div>
            </div>
          }
          {/* 
          {pettyCashTypes[cashDetails?.cashFor] ===
            "Pickup And Delivery Reimbursement" && (
            <div>
              <div className="bg-white text-center w-screen md:w-full grid grid-cols-1 md:grid-cols-5 my-4 rounded-lg p-4">
                <div className="col-span-1">
                  <h2 className="text-sm font-medium text-gray-600 mb-1">
                    Executive Name
                  </h2>
                  <p className="text-gray-800 font-medium">
                    {cashDetails?.requestBy}
                  </p>
                </div>
                <div className="col-span-1">
                  <h2 className="text-sm font-medium text-gray-600 mb-1">
                    Executive Mail
                  </h2>
                  <p className="text-gray-800 font-medium">
                    {cashDetails?.requestByEmail}
                  </p>
                </div>
                <div className="col-span-1">
                  <h2 className="text-sm font-medium text-gray-600 mb-1">
                    PettyCash Id
                  </h2>
                  <p className="text-gray-800 font-medium">{cashDetails?.id}</p>
                </div>

                <div className="col-span-1">
                  <h2 className="text-sm font-medium text-gray-600 mb-1">
                    Petty Cash Category
                  </h2>
                  <p className="text-gray-800 font-medium">
                    {pettyCashStatus[cashDetails?.pettyCashStatus]}
                  </p>
                </div>
                <div className="col-span-1">
                  <h2 className="text-sm font-medium text-gray-600 mb-1">
                    Start to End Date
                  </h2>
                  <p className="text-gray-800 font-medium">
                    {formatDate(formattedStartDate) +
                      " to " +
                      formatDate(formattedEndDate)}
                  </p>
                </div>
              </div>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="employee table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Requested By</TableCell>
                      <TableCell>Cash For</TableCell>
                      <TableCell>Created At</TableCell>
                      <TableCell align="right">Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsEmplyee.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>{row.requestedby}</TableCell>
                        <TableCell>{row.cashfor}</TableCell>
                        <TableCell>{row.createdat}</TableCell>
                        <TableCell align="right">{row.amount}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableBody className="text-lg font-bold">
                    <TableCell align="right">
                      Total -{" "}
                      {rowsEmplyee.reduce(
                        (sum, item) => sum + (item?.amount || 0),
                        0
                      )}
                    </TableCell>
                  </TableBody>
                </Table>
              </TableContainer>

              {pettyCashTypes[cashDetails?.cashFor] ===
                "Pickup And Delivery Reimbursement" &&
                pettyCashStatus[cashDetails?.pettyCashStatus] === "Requested" &&
                isUserAuthorizedForAmount(
                  rowsEmplyee.reduce(
                    (sum, item) => sum + (item?.amount || 0),
                    0
                  ),
                  approvalDetails,
                  profile?.id
                ) && (
                  <div className="flex justify-end">
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#0703fc",
                        "&:hover": { backgroundColor: "#4a47ed" },
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        fontWeight: "bold",
                        my: 2,
                      }}
                      onClick={() =>
                        handleApproveCashRequest(
                          pettyCashStatus?.inverted?.verified
                        )
                      }
                    >
                      Pay
                    </Button>
                  </div>
                )}
            </div>
          )} */}

          {transactionDetails?.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
              <h1 className="font-bold md:text-2xl text-gray-800">
                Transaction Details
              </h1>
              <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="dynamic table"
                  >
                    <TableHead>
                      <TableRow className="bg-gray-100">
                        {/* Dynamically render headers */}
                        {rows.length > 0 &&
                          Object.keys(rows[0]).map((key) => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, index) => (
                        <TableRow key={index}>
                          {Object.entries(row).map(([key, value], idx) => (
                            <TableCell key={idx}>
                              {key === "attachments" && value ? (
                                <div
                                  title="image"
                                  className="flex gap-4 items-center cursor-pointer"
                                >
                                  {value.map((item, index) => (
                                    <div
                                      onClick={() => {
                                        handleImageOpen(
                                          item?.url ? item?.url : item?.path
                                        );
                                      }}
                                      key={index}
                                      className="items-center gap-2"
                                    >
                                      <img
                                        src={item?.url}
                                        alt="Attachment"
                                        className="w-8 h-8 object-contain"
                                      />
                                      {/* <div href={item?.url} title="download">
                                        <CloudDownloadIcon
                                          className="cursor-pointer"
                                          onClick={(e) =>
                                            handleDownload(
                                              e,
                                              item?.url,
                                              item?.name
                                            )
                                          }
                                        />
                                      </div> */}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          )}
          <div className="flex gap-4 justify-between">
            {actionsToAccess?.includes("Petty Cash Add Transactions") &&
              cashDetails?.pettyCashStatus ===
                Number(pettyCashStatus?.inverted?.verified) && (
                <div className="mt-6  items-center">
                  <Button
                    onClick={() => handleOpen("transaction")}
                    variant="contained"
                  >
                    Add Transaction Details
                  </Button>
                </div>
              )}
          </div>
          {billDetails?.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
              <h1 className="font-bold md:text-2xl text-gray-800">
                Bill Details
              </h1>
              <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="dynamic table"
                  >
                    <TableHead>
                      <TableRow className="bg-gray-100">
                        {/* Dynamically render headers */}
                        {billRows.length > 0 &&
                          Object.keys(billRows[0]).map((key) => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {billRows.map((row, index) => (
                        <TableRow key={index}>
                          {Object.entries(row).map(([key, value], idx) => (
                            <TableCell key={idx}>
                              {key === "attachments" && value ? (
                                <div
                                  title="image"
                                  className="flex gap-4 items-center cursor-pointer"
                                >
                                  {value.map((item, index) => (
                                    <div
                                      key={index}
                                      className="items-center gap-2"
                                    >
                                      <img
                                        src={item?.url}
                                        alt="Attachment"
                                        className="w-8 h-8 object-contain"
                                      />
                                      {/* <div title="download">
                                      <CloudDownloadIcon
                                        className="cursor-pointer"
                                        onClick={(e) =>
                                          handleDownload(
                                            e,
                                            item?.url,
                                            item?.name
                                          )
                                        }
                                      />
                                    </div> */}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          )}
          {cashDetails?.pettyCashStatus ===
            Number(pettyCashStatus?.inverted?.verified) &&
            actionsToAccess?.includes("Petty Cash Add Bill Details") && (
              <div className="mt-6 flex gap-4 justify-between items-center">
                <Button onClick={() => handleOpen("bill")} variant="contained">
                  Add Bill Details
                </Button>
              </div>
            )}
          {transactionDetails?.length > 0 &&
            actionsToAccess?.includes("Approve Petty Cash Request") &&
            cashDetails?.pettyCashStatus ===
              Number(pettyCashStatus?.inverted?.verified) && (
              <div className="md:col-span-1 items-center mx-auto p-6 mt-4 md:mt-0">
                <div className="flex gap-4">
                  <TextField
                    sx={{
                      width: "60%",
                    }}
                    label="Approval Description"
                    variant="outlined"
                    onChange={(e) => setComment(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: "#05ab4d",
                      "&:hover": { backgroundColor: "#00e64d" },
                      px: 4,
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: "bold",
                    }}
                    onClick={() =>
                      handleApproveCashRequest(
                        pettyCashStatus?.inverted?.cashCompleted
                      )
                    }
                  >
                    Cash Completed
                  </Button>
                </div>
              </div>
            )}
        </>
      )}
    </>
  );
};

export default Pettcashdetailtab;
